
import { defineComponent, onMounted, reactive, toRefs, watch } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  props: {
    navList: {
      type: Array,
      default: () => []
    }
  },
  setup(props, contex) {
    const router = useRouter()
    const navData: any = []
    const proxyData = reactive({
      activeCode: 'air',
      navData: navData,
      setNavValue(val: any) {
        proxyData.navData = val
      },
      checkNav(item: any, index: any) {
        proxyData.activeCode = item.code
        contex.emit('changeNav', item)
      },
      setActiveCode(activeCode: any) {
        proxyData.activeCode = activeCode
      }
    })
    watch(
      props.navList, (newVal, oldValue) => {
        proxyData.setNavValue(newVal)
      }
    )
    onMounted(() => {
      proxyData.setNavValue(props.navList)
    })
    return {
      ...toRefs(proxyData)
    }
  }
})
